import { render, staticRenderFns } from "./DepositIncomPopup.vue?vue&type=template&id=2ca7fb1e&scoped=true&"
import script from "./DepositIncomPopup.vue?vue&type=script&lang=js&"
export * from "./DepositIncomPopup.vue?vue&type=script&lang=js&"
import style0 from "./DepositIncomPopup.vue?vue&type=style&index=0&id=2ca7fb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca7fb1e",
  null
  
)

export default component.exports